import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import "./ContactInfo.css";
import "../../components/header/userMenu/SettingsPrivacy.css";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000";

const BackIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);

export default function ContactInfoPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useSelector((state) => state);

  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (user && user.token) {
        try {
          const res = await axios.get(`${API_URL}/getProfile/${user.username}`, {
            headers: { Authorization: `Bearer ${user.token}` },
          });
          if (res.data && (res.data.user || res.data.email || res.data._id)) {
            const profileData = res.data.user || res.data;
            setUserProfile(profileData);
          } else {
            setUserProfile(user);
          }
        } catch (err) {
          console.error("Failed to fetch user profile:", err);
          setUserProfile(user);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchUserProfile();
  }, [user]);

  const handleBack = () => {
    if (location.state?.from) {
      navigate(location.state.from);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="contact_info_page">
      <header className="contact_info_page_header">
        <button className="contact_info_page_back" onClick={handleBack} aria-label="Go back">
          <BackIcon />
        </button>
        <h1>Contact information</h1>
      </header>

      <main className="contact_info_page_body">
        {loading ? (
          <div className="contact_info_loading">Loading...</div>
        ) : (
          <div className="contact_info_page_card">
            <div className="contact_info_list">
              {userProfile?.email && (
                <div className="contact_info_item" style={{ cursor: "default" }}>
                  <div className="contact_info_icon">
                    <EmailIcon />
                  </div>
                  <div className="contact_info_text">
                    <span className="contact_info_value">{userProfile.email}</span>
                  </div>
                </div>
              )}

              {userProfile?.additionalEmails &&
                userProfile.additionalEmails.length > 0 &&
                userProfile.additionalEmails.map((email, index) => (
                  <div key={index} className="contact_info_item" style={{ cursor: "default" }}>
                    <div className="contact_info_icon">
                      <EmailIcon />
                    </div>
                    <div className="contact_info_text">
                      <span className="contact_info_value">{email}</span>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}

